export default __webpack_public_path__ + "static/media/home.c10f3e1e.svg";